import * as React from 'react';

interface IApiClientContext {
	baseUrl: string;
}

const ApiClientContext = React.createContext<IApiClientContext | undefined>(undefined);

export const ApiClientContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const baseUrl = import.meta.env.VITE_API_URL || '';

	return <ApiClientContext.Provider value={{ baseUrl }}>{children}</ApiClientContext.Provider>;
};

export const useApiClient = (): IApiClientContext => {
	const context = React.useContext(ApiClientContext);
	if (!context) {
		throw new Error('useApiClient must be used within ApiClientContextProvider');
	}
	return context;
};
